import React from 'react';
import './DashboardHeader.scss';
const DashboardHeaderLoading = () => {

  return (
    <div className="dashboard-header" style={{ width: 'auto', height: '120px', backgroundColor: 'lightgrey' }}>
    </div>
  )
};

export default DashboardHeaderLoading;
